import React, { useState } from "react";
import "./App.css";
import DaveHash, { hashes, HashFn, ShowHashDesc } from "./DaveHash";

function App() {
    let [name, setName] = useState("");
    let [yVowel, setYVowel] = useState(true);
    let [size, setSize] = useState(10);
    let [hash_fn, setHashFn] = useState(() => hashes[0].fn);

    return (
        <div className="App App-header">
            <input onChange={e => setName(e.target.value)} value={name}></input>
            <div style={{ display: "flex" }}>
                <p>Y is a vowel:</p>
                <input
                    type="checkbox"
                    checked={yVowel}
                    onChange={_ => setYVowel(!yVowel)}
                ></input>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <p>Sylladex size:</p>
                <input
                    onChange={e => {
                        let new_size = parseInt(e.target.value, 10);
                        return setSize(new_size == new_size ? new_size : 0);
                    }}
                    value={size}
                    width="10vw"
                ></input>
            </div>
            <div
                className="hash-fns"
                children={hashes.map((h, i) => (
                    <div
                        key={i}
                        onClick={() => setHashFn(() => h.fn)}
                        className={
                            `${h.fn}` == `${hash_fn}` ? "active-hash-fn" : ""
                        }
                    >
                        <ShowHashDesc bla={h.bla} />
                    </div>
                ))}
            ></div>
            <br />
            <DaveHash
                text={name}
                y_vowel={yVowel}
                sylladex_size={size}
                hash_fn={hash_fn}
            />
        </div>
    );
}

// TODO: more hash functions (configurable) and, like, an actual sylladex thingy (optional detect collisions)

export default App;
